<div id="idx+'table'" #dataTable class="w-100 d-flex flex-column common-table">
  <p *ngIf="!dataSource.data">No Data given in Table</p>
  <div class="table-wrapper mat-elevation-z8">
    <div class="sr-only">Hidden Text</div>
    <table mat-table role="table"
      [dataSource]="dataSource"
      matSort (matSortChange)="sortData($event)"
      matSortDisableClear
      [matSortDisabled]="!tableConfig?.tableSort?.enableSorting"
      [matSortActive]="tableConfig?.tableSort?.sortActive || ''"
      [matSortDirection]="tableConfig?.tableSort?.sortDirection || 'asc'"
      [multiTemplateDataRows]="rowExpandable">
    <!-- All Data Columns in a for loop-->
    <ng-container *ngFor="let column of tableConfig.columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="{'width':column.columnWidth}" role="columnheader">
        <div class="column-title" style="margin: 0;"> {{column.columnTitle}} </div>
      </th>
      <ng-container *ngIf="rowExpandable; else noRowExpTd">
        <td class="mat-body-2" mat-cell *matCellDef="let element; let i = dataIndex" role="cell">
          <!-- Default template for data elements -->
          <ng-template #defaultElement let-element let-column="col" let-idx="idx">
            {{element[column.dataKey]}}
          </ng-template>
          <!-- Data set in td through template -->
          <ng-container
          [ngTemplateOutlet]="dataTemplate || defaultElement"
          [ngTemplateOutletContext]="{ $implicit: element, col: column, idx: i+1 }">
          </ng-container>
        </td>
      </ng-container>
      <ng-template #noRowExpTd>
        <td class="mat-body-2" mat-cell *matCellDef="let element; let i = index" role="cell">
          <!-- Default template for data elements -->
          <ng-template #defaultElement let-element let-column="col" let-idx="idx">
            {{element[column.dataKey]}}
          </ng-template>
          <!-- Data set in td through template -->
          <ng-container
          [ngTemplateOutlet]="dataTemplate || defaultElement"
          [ngTemplateOutletContext]="{ $implicit: element, col: column, idx: i+1 }">
          </ng-container>
        </td>
      </ng-template>
    </ng-container>

    <!-- Expand toggle Column -->
    <ng-container matColumnDef="expand" *ngIf="rowExpandable">
      <th style="width: 10%;" class="column-title" mat-header-cell *matHeaderCellDef role="columnheader">
        <span class="sr-only">Expand/Collapse</span> <span>&nbsp;</span>
      </th>
      <td mat-cell *matCellDef="let element; let i = dataIndex" role="cell">
        <button mat-icon-button [attr.aria-expanded]="expandedElement === element" attr.aria-labelledby="expIcon{{i+1}}"
        (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
          <mat-icon aria-label="moreInfo" class="exp-toggle-icon-down" *ngIf="expandedElement !== element" id="expIcon{{i+1}}"></mat-icon>
          <mat-icon aria-label="lessInfo" class="exp-toggle-icon-up" *ngIf="expandedElement === element" id="expIcon{{i+1}}"></mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail" *ngIf="rowExpandable">
      <td style="padding: 0 1rem;" mat-cell *matCellDef="let element; let i = dataIndex"
      [attr.colspan]="columnsToDisplay.length" role="columnheader">
        <div *ngIf="element === expandedElement" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
          <ng-template #defaultTemplate let-element let-idx="rowIndex">
            <p class="w-100 text-center">Expanded View for rowIndex : {{idx}}</p>
          </ng-template>
          <ng-container
                [ngTemplateOutlet]="expandTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{$implicit:element, rowIndex:i+1}">
          </ng-container>
        </div>
      </td>
    </ng-container>

    <tr role="row" mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <!-- tr for expandable rows -->
    <ng-container *ngIf="rowExpandable">
      <tr role="row" mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
      <tr role="row" style="height: 0px;" mat-row *matRowDef="let element; columns: ['expandedDetail'];"></tr>
    </ng-container>
    <!-- tr for normal rows -->
    <ng-container *ngIf="!rowExpandable">
      <tr role="row" mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
    </ng-container>
    </table>
  </div>
  <div id="pag" #pag class="w-100 d-flex flex-row mat-elevation-z8" *ngIf="tableConfig?.pagination?.showPagination">
    <mat-paginator #paginator class="common-paginator"
      [hidePageSize]="!tableConfig?.pagination?.showPageSize"
      [pageSizeOptions]="tableConfig?.pagination?.pageSizeOptions || [5,10]"
    [showFirstLastButtons]="tableConfig?.pagination?.showFirstLastButtons">
    </mat-paginator>
  </div>
</div>
